module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-600.b56c7e1d.woff2";